import { QueryResult } from '@apollo/client'
import { GetRfiOrganizationsQuery, useGetRfiOrganizationsQuery } from 'schema'
import { createStrictContext } from 'utils/createContext'
import { DefaultQueryHookOptions } from 'utils/defaults'
import { useProjectContext } from 'context/ProjectContext'

type GetRfiOrganizationsQueryResult = QueryResult<GetRfiOrganizationsQuery>
export type RFIOrganization =
  GetRfiOrganizationsQuery['rfiOrganizations']['records'][0]

const { Provider, useContextFn } = createStrictContext<{
  records: RFIOrganization[]
  refetch: GetRfiOrganizationsQueryResult['refetch']
  fetching: GetRfiOrganizationsQueryResult['loading']
}>('OrganizationsTableContext')

export const useOrganizationsTableContext = useContextFn

export const OrganizationsTableProvider: React.FC = ({ children }) => {
  const { projectId } = useProjectContext()
  const {
    data,
    refetch,
    loading: fetching,
  } = useGetRfiOrganizationsQuery({
    ...DefaultQueryHookOptions,
    variables: {
      rfiOrganizationListInput: {
        projectId: { equals: projectId },
      },
    },
  })
  return (
    <Provider
      value={{
        records: data?.rfiOrganizations?.records ?? [],
        refetch,
        fetching,
      }}
    >
      {children}
    </Provider>
  )
}
